import { kea } from 'kea'
import PropTypes from "prop-types";
import { forEach, get } from 'lodash'
import { put } from 'redux-saga/effects'

import entities from '~/entities'
import { selector as configSelector } from '~/config'

import rootLogic from '~/scenes/logic'
import { form as formLogic } from './contact-form/logic'

export default kea({
  path: () => ['scenes', 'contact', 'index'],

  connect: {
    actions: [
      rootLogic, [
        'next',
        'setUserInfo'
      ],
      formLogic, [
        'submit',
        'submitSuccess'
      ]
    ],
    values: [
      rootLogic, [
        'loggedIn',
        'loading',
        'userInfo',
        'shippingRequired'
      ],
    ],
  },

  selectors: ({ constants, selectors }) => ({

    itemsLoginRequired: [
      () => [
        entities.selectors.activeCart
      ], (activeCart) => {
        if(activeCart) {
          let loginRequired = false;
          forEach(activeCart.contents, (val) => {
            if(val && val.login_required) {
              loginRequired = true;
              return false;
            }
          });
          return loginRequired
        }

        return false;
      },
      PropTypes.bool
    ],

    accountSetting: [
      () => [
        entities.selectors.activeShop
      ], (activeShop) => {
        return get(activeShop, 'checkout_settings.accounts', 'disabled')
      },
      PropTypes.string
    ],

    showContactForm: [
      () => [
        selectors.loggedIn,
        selectors.itemsLoginRequired,
        selectors.accountSetting
      ], (loggedIn, loginRequired, accountSetting) => {
        if(loggedIn) {
          return true;
        }

        //TODO: fix magic string
        return  !loginRequired && accountSetting !== 'required';
      },
      PropTypes.bool
    ],

    showLogin: [
      () => [
        selectors.loggedIn,
        selectors.itemsLoginRequired,
        selectors.accountSetting
      ], (loggedIn, loginRequired, accountSetting) => {
        if(loggedIn) {
          return false;
        }

        //TODO: fix magic strings
        return (accountSetting === 'optional' || accountSetting === 'required' || loginRequired);
      },
      PropTypes.bool
    ],

    loginRequired: [
      () => [
        selectors.showLogin,
        selectors.showContactForm,
      ], (showLogin, showContactForm) => {
        return showLogin && !showContactForm;
      },
      PropTypes.bool
    ],

    guestAllowed: [
      () => [
        selectors.showLogin,
        selectors.showContactForm,
      ], (showLogin, showContactForm) => {
        return showLogin && showContactForm;
      },
      PropTypes.bool
    ]
  }),

  start: function * () {

  },

  takeLatest: ({actions, workers}) => ({
    [actions.submitSuccess]: function*() {
      yield put(actions.next())
    },
    [actions.setUserInfo]: function*(action) {
      console.log('user info', action.payload, action);
    }
  })
})
